import api from '../../api';
import CRUD from '../../components/CRUD';
import {
    formatDate,
    normalizeDateFields,
    normalizeOutDateFields
} from '../../utils/normalize';
import MeetingEveningProgramForm from './MeetingEveningProgramForm';


const MeetingEveningProgramList = ({parentId, parentName}) => {
    const columns = [
        {
            title: 'Datum',
            dataIndex: 'date_program',
            key: 'date_program',
            render: (text => {
               return formatDate(text)
            }),
            sorter: (a, b) => a.date_program > b.date_program,
        },
        {
            title: 'Uhrzeit',
            dataIndex: 'time_program',
            key: 'time_program',
            sorter: (a, b) => a.time_program > b.time_program,
        },
        {
            title: 'Abendprogramm',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name > b.name,
        },
        {
            title: 'Maximale Teilnehmerzahl',
            dataIndex: 'max_members',
            key: 'max_members',
        },
    ];

    const normalizeFormData = (data) => {
        if (data['id']) data['set_statuses'] = data['statuses'];
        return normalizeDateFields(data, ['date_program']);
    }

    const normalizeSendData = (data) => {
        return normalizeOutDateFields(data, ['date_program']);
    }

    return <CRUD
        keyName="meeting-evening-program"
        title="Liste Abendprogramme zur Tagung"
        FormComponent={MeetingEveningProgramForm}
        tableColumns={columns}
        apiList={api.meetings.meetingEveningProgramList}
        apiRetrieve={api.meetings.meetingEveningProgramRetrieve}
        apiCreate={api.meetings.meetingEveningProgramCreate}
        apiUpdate={api.meetings.meetingEveningProgramUpdate}
        apiDelete={api.meetings.meetingEveningProgramDelete}
        itemValueName="name"
        itemName="abendprogramm"
        parentField="meeting"
        parentId={parentId}
        parentName={parentName}
        normalizeFormData={normalizeFormData}
        normalizeSendData={normalizeSendData}
    />
};

export default MeetingEveningProgramList;
